<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Toolbar.consentlist") }}</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap fill-height justify-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-tabs v-model="tab" align-with-title color="#077893">
                <!-- {{$t('consentlist.generalconsent')}} -->

                <v-tabs-slider color="#077893"></v-tabs-slider>

                <v-tab v-for="item in items" :key="item">
                  {{ $t(item) }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <AllConsent />
                </v-tab-item>
                <v-tab-item>
                  <GeneralConsent />
                </v-tab-item>
                <v-tab-item>
                  <GroupConsent />
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AllConsent from "@/views/Email/ConsentList/AllConsent.vue";
import GeneralConsent from "@/views/Email/ConsentList/GeneralConsent.vue";
import GroupConsent from "@/views/Email/ConsentList/GroupConsent.vue";

export default {
  components: { GeneralConsent, GroupConsent, AllConsent },
  data: function () {
    return {
      tab: null,
      items: [
        "consentlist.allconsent",
        "consentlist.generalconsent",
        "consentlist.groupconsent",
      ],
    };
  },
  computed: {},
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
